import { render, staticRenderFns } from "./TicketForm.vue?vue&type=template&id=e0647cba&scoped=true&"
import script from "./TicketForm.vue?vue&type=script&lang=js&"
export * from "./TicketForm.vue?vue&type=script&lang=js&"
import style0 from "./TicketForm.vue?vue&type=style&index=0&id=e0647cba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0647cba",
  null
  
)

export default component.exports